var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesTabsIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.64,
    fill: "#5091EE",
    d: "M33 23v8h3V20H25v3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2174EA",
    d: "M20 25h11v11H20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTabsIcon02);
export default __webpack_public_path__ + "static/media/features-tabs-icon-02.42b732ac1dae48c651699640cc432290.svg";
export { ForwardRef as ReactComponent };